import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Spinner from 'react-bootstrap/Spinner'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Table from 'react-bootstrap/Table'
import { toast } from 'react-toastify'
import Paginacion from 'components/Paginacion'
import api from 'api/api'

import './investigacion.css'
import NuevaInvestigacion from './NuevaInvestigacion'
import { DEFAULT_FETCH_CUANTOS } from 'utils/constants'
import { debounce } from 'utils/debounce'
import VerInvestigacion from './VerInvestigacion'
import EliminarInvestigacion from './EliminarInvestigacion'
import EditarInvestigacion from './EditarInvestigacion'
import { getFileData } from 'utils/general'


function Investigacion(props) {
	const [fetchDeACuantos, setFetchDeACuantos] = useState(DEFAULT_FETCH_CUANTOS)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	const [busqueda, setBusqueda] = useState('')
	const [filtroBusqueda, setFiltroBusqueda] = useState('')
	const [investigaciones, setInvestigaciones] = useState([])
	const [investigacionActual, setInvestigacionActual] = useState()
	const [queMostrar, setQueMostrar] = useState('')
	const [etiquetas, setEtiquetas] = useState([])

	const opcionesCuantosMostrar = [10, 25, 50]

	const refreshConfig = async () => {
		try {
			const { datos } = await api.get('p/config-investigaciones')
			setEtiquetas(datos.etiquetas)
		} catch (error) {
			toast.error('Error al obtener configuración')
		}
	}

	const refreshInvestigaciones = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('p/ver-investigaciones', {
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					titulo: [filtroBusqueda],
					autor: [filtroBusqueda],
					planta: [filtroBusqueda],
					etiqueta: [filtroBusqueda]
				}
			})

			setInvestigaciones(datos.investigaciones)
			setNumResultados(datos.numResultados)
		} catch (error) {
			toast.error('Error de conexión')
			console.error(error)
		} finally {
			setLoading(false)
		}
	}

	const handleBusqueda = (value) => {
		if (value) {
			setFiltroBusqueda(value)
		} else {
			setFiltroBusqueda('')
		}
	}

	const debouceFiltroBusqueda = React.useCallback(
		debounce(handleBusqueda, 400),
		[]
	)

	useEffect(() => {
		debouceFiltroBusqueda(busqueda)
	}, [busqueda])

	useEffect(() => {
		if (paginaAct === 1) {
			refreshInvestigaciones()
		} else {
			setPaginaAct(1)
		}
	}, [filtroBusqueda, fetchDeACuantos])

	useEffect(() => {
		if (!loading) {
			refreshInvestigaciones()
		}
	}, [paginaAct])

	const handleAction = (comunicado, cual) => {
		setInvestigacionActual(comunicado, setQueMostrar(cual))
	}

	// Función para subir documento (similar a InformacionPublica)
	const subirDocumento = async (data) => {
		setLoading(true)
		let documentoData = new FormData()
		documentoData.append('documento', data.documento)
		const config = {
			headers: {
				'Content-Type': 'multipart/form-data',
			}
		}
		try {
			const { datos: respuesta, msg, error } = await api.post('a/documentos', documentoData, config)

			if (!error) {
				console.info('Documento guardado exitosamente', respuesta)
				delete data.documento
				data.documentoId = respuesta.id
				if (data.id) {
					guardarDatosEdicion(data)
				} else {
					guardarDatosNuevo(data)
				}
			}
		} catch (error) {
			console.error(error)
			toast.error('Error al subir documento')
		}
	}

	// Función para guardar datos de nueva investigación (sin documento)
	const guardarDatosNuevo = async (data) => {
		setLoading(true)
		try {
			const { msg } = await api.post('a/investigaciones', data)
			refreshConfig()
			refreshInvestigaciones()
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		} finally {
			setLoading(false)
		}
	}

	// Función para guardar datos de edición (sin documento)
	const guardarDatosEdicion = async (data) => {
		setLoading(true)
		try {
			const { msg } = await api.put('a/investigaciones/' + data.id, data)
			refreshConfig()
			refreshInvestigaciones()
			setQueMostrar('')
			toast.success(msg)

			// Si hay documento pendiente, subirlo
			if (data.documento) {
				subirDocumento(data)
			}
		} catch (error) {
			console.error(error)
			toast.error('Error de conexión')
		} finally {
			setLoading(false)
		}
	}

	// Función principal que maneja el guardado (similar a InformacionPublica)
	const guardar = (data) => {
		if (data.documento) {
			// Si hay documento, primero lo subimos
			subirDocumento(data)
		} else {
			// Si no hay documento, guardamos directamente
			delete data.documento
			if (data.id) {
				guardarDatosEdicion(data)
			} else {
				guardarDatosNuevo(data)
			}
		}
	}

	const eliminarInvestigacion = async (id) => {
		const { msg } = await api.delete('a/investigaciones/' + id)
		refreshConfig()
		refreshInvestigaciones()
		setQueMostrar('')
		toast.success(msg)
	}

	useEffect(() => {
		if (!loading) {
			refreshConfig()
			refreshInvestigaciones()
		}
	}, [])

	const extraerAnio = (fechaString) => {
		return fechaString.substring(0, 4);
	}


	// render
	return (
		<Container fluid id="investigaciones" className="vh-100">
			<Row className="d-flex no-gutters">
				<Col xs={12} className="mt-2">
					<h1>Investigaciones científicas</h1>
					<hr />
				</Col>
			</Row>
			<Row className="d-flex no-gutters">
				<Col className="mt-2">
					<Form>
						<Row id="searchbar" className="justify-content-between align-items-center">
							<Col sm={6} md={3} style={{ display: 'block' }}>
								<small>
									<span className="d-none d-sm-inline-block">Mostrar de a</span>
									<Form.Group style={{ display: 'inline-block' }}>
										<Form.Select size="sm" onChange={(e) => setFetchDeACuantos(e.target.value)} className="mx-1">
											{opcionesCuantosMostrar.map((o) => {
												return (
													<option value={o} key={`mostrar-${o}`}>
														{o}
													</option>
												)
											})}
										</Form.Select>
									</Form.Group>
									<span className="ms-2">investigaciones</span>
								</small>
							</Col>
							<Col md={5} lg={4}>
								<Form.Group controlId="txtBusqueda">
									<InputGroup>
										<Form.Control
											autoFocus
											value={busqueda}
											onChange={(e) => setBusqueda(e.target.value)}
											type="text"
											placeholder="Buscar"
											aria-label="Buscar"
										/>
										<InputGroup.Text><Form.Label className="mb-0"><i className="fa fa-search"></i></Form.Label></InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Col>
			</Row>
			<Row className="d-flex no-gutters justify-content-between align-items-end mt-2">
				<Col>
					<Button onClick={() => setQueMostrar('nueva')} variant="primary">
						<i className="fa fa-plus"></i> Nueva investigación
					</Button>
				</Col>
				<Col className="text-end">
					<small>Total resultados: <strong>{numResultados}</strong></small>
				</Col>
			</Row>
			{/* Table */}
			<Row>
				<Col>
					<Table id="tabla-investigaciones" className="mt-2" bordered hover>
						<thead>
							<tr>
								<th>Id</th>
								<th>Título</th>
								<th>Año</th>
								<th>Autor</th>
								<th>Planta</th>
								<th>Etiquetas</th>
								<th>Documento</th>
								<th>Acciones</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan="8">
										<Spinner
											animation="border"
											size="lg"
											role="status"
											aria-hidden="true"
											variant="primary"
											className="my-3"
										/>
									</td>
								</tr>
							) : (
								investigaciones.length === 0 ? (
									<tr>
										<td colSpan="7">
											<Alert variant="info">No se encontraron investigaciones</Alert>
										</td>
									</tr>
								) : (
									investigaciones.map((investigacion, index) => {
										const documentoFileData = getFileData(investigacion.documento?.url)
										const labelsDeEtiquetas = investigacion.etiquetas?.length > 0 ?
											investigacion.etiquetas.map(elem => elem.nombre).join(', ') : '-'

										return (
											<tr key={investigacion.id}>
												<td>{investigacion.id}</td>
												<td>{investigacion.titulo}</td>
												<td>{extraerAnio(investigacion.fechaPublicacion)}</td>
												<td>{investigacion.autor}</td>
												<td>{investigacion.planta}</td>
												<td>{labelsDeEtiquetas}</td>
												<td>{<i className={documentoFileData.icono}></i>}</td>
												<td>
													<Button
														onClick={() => handleAction(investigacion, 'ver')}
														className="me-2"
														variant="primary"
													>
														<i className="fa fa-eye"></i>
													</Button>
													<Button
														onClick={() => handleAction(investigacion, 'editar')}
														className="me-2"
														variant="secondary"
													>
														<i className="fa fa-pencil"></i>
													</Button>
													<Button
														onClick={() => handleAction(investigacion, 'eliminar')}
														variant="danger"
													>
														<i className="fa fa-trash"></i>
													</Button>
												</td>
											</tr>
										)
									})
								)
							)}
						</tbody>
					</Table>
				</Col>
			</Row>
			<Row>
				<Col>
					<Paginacion
						pagina={paginaAct}
						numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
						setPagina={setPaginaAct}
					/>
				</Col>
			</Row>

			{/* Panel Nuevo */}
			{queMostrar === 'nueva' && (
				<NuevaInvestigacion
					etiquetasExistentes={etiquetas}
					guardar={guardar}
					setQueMostrar={setQueMostrar}
				/>
			)}
			{/* Panel Ver */}
			{investigacionActual && queMostrar === 'ver' &&
				<VerInvestigacion
					investigacion={investigacionActual}
					setQueMostrar={setQueMostrar}
				/>
			}
			{/* Panel Editar */}
			{investigacionActual && queMostrar === 'editar' &&
				<EditarInvestigacion
					investigacionOriginal={investigacionActual}
					etiquetasExistentes={etiquetas}
					setQueMostrar={setQueMostrar}
					guardar={guardar}
				/>
			}
			{/* Modal Delete */}
			{
				investigacionActual && queMostrar === 'eliminar' &&
				<EliminarInvestigacion
					investigacion={investigacionActual}
					setQueMostrar={setQueMostrar}
					eliminar={eliminarInvestigacion}
				/>
			}
		</Container>
	);
}

export default Investigacion